const blogData = {
	blogList: [
		{
			title: "Github Pages Deployment ✔",
			group: "Deployment",
			bgColor: "#926685",
			description: "무료호스팅 도구인 Github Pages를 통한 무료호스팅으로 배포하는 방법을 기재했습니다.",
			link: "https://itscassiekim.tistory.com/263",
		},
		{
			title: "리액트 개발환경 구축 0부터 🚩",
			group: "Nodejs",
			bgColor: "#776692",
			description: "리액트 처음부터 프로젝트 구축하는 법을 정리했다.",
			link: "https://itscassiekim.tistory.com/217",
		},
		{
			title: "실전형 Hooks 🚩",
			group: "React",
			bgColor: "#776692",
			description: "리액트 처음부터 프로젝트 구축하는 법을 정리했다.",
			link: "https://itscassiekim.tistory.com/46",
		},
		{
			title: "화살표 함수, JSX, 다중클래스 할당, ARIA-LABEL 🚥",
			group: "Algorithm",
			bgColor: "#667b92",
			description: "화살표 함수, JSX, 다중클래스 할당, ARIA-LABEL 정의들을 정리했습니다.",
			link: "https://itscassiekim.tistory.com/8",
		},
		{
			title: "SYMBOL",
			group: "Javascript",
			bgColor: "#66928f",
			description: "SYMBOL에 대해서 정리했습니다.",
			link: "https://itscassiekim.tistory.com/296",
		},
		{
			title: "NODE.JS VS VPM",
			group: "NODE.JS",
			bgColor: "#66928f",
			description: "NODE.JS VS VPM의 차이점을 정리했습니다.",
			link: "https://itscassiekim.tistory.com/272",
		},
		{
			title: "시맨틱코드, padStart()함수 string.padStart(목표길이, 채울 값), for문 🙋‍♀️",
			group: "Javascript",
			bgColor: "#66928f",
			description: "미니프로젝트의 코드를 적용하면서 배운 점과 netlify 배포하는 법을 정리했습니다. ",
			link: "https://itscassiekim.tistory.com/99",
		},
		{
			title: "useMemo & useCallback",
			group: "React Hooks[",
			bgColor: "#926666",
			description: "useMemo & useCallback 개념에대해서 정리했습니다.",
			link: "https://itscassiekim.tistory.com/60",
		},
	],
};

export default blogData;

